export const ADD = (a, b) => a + b;

export const AND = (a, b) => a && b;

export const OR = (a, b) => a || b;

export const SUBTRACT = (a, b) => a - b;

export const XOR = (a, b) => OR(AND(a, !b), AND(!a, b));
